import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import {
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomError,
  HttpRequestMethods,
  handleError,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, of, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountSnapshotResponse } from '../../models/api/account-snapshot.interfaces';
import {
  CommonRequest,
  PayloadRequest
} from '../../models/api/tracker.interfaces';
import {
  COMMON_HEADER_KEY,
  TYPE,
  commonHeaderInfo
} from '../../models/overview.constants';

@Injectable({
  providedIn: 'root'
})
export class SnapshotService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getSnapshot = (
    request: CommonRequest
  ): Observable<AccountSnapshotResponse | undefined> => {
    const queryParams = {
      postedActivityCount: '3'
    };
    commonHeaderInfo['X-Delta-DLCOM_Loyalty_App_Test'] = COMMON_HEADER_KEY;
    commonHeaderInfo['Authorization'] = this.session.token.access_token;
    const payload: PayloadRequest = { carrierCode: request.carrierCode };
    if (request.carrierCode) {
      return new ApiBuilder<PayloadRequest, AccountSnapshotResponse>(
        this.http,
        this.appConfig
      )
        .overrideEndpoint([
          {
            src: TYPE.POSTED_ACTIVITY_COUNT,
            target: queryParams.postedActivityCount
          }
        ])
        .app(IDP_APPS.SKYMILES)
        .endpointKey(EndpointKeys['SKYMILES_API_ACCOUNT_ACTIVITY'])
        .method(HttpRequestMethods['POST'])
        .payload(payload)
        .httpHeaders(commonHeaderInfo)
        .timeOut(request.timeout)
        .retries(request.retry)
        .errorHandler(handleError.bind(this))
        .library(Libraries.OVERVIEW)
        .withCredentials(true)
        .create()
        .pipe(
          map((response: AccountSnapshotResponse | CustomError) => {
            return this.existCustomError(response);
          })
        );
    }
    return of(undefined);
  };

  existCustomError(
    response: AccountSnapshotResponse | CustomError
  ): AccountSnapshotResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeys.SKYMILES_API_ACCOUNT_ACTIVITY
      );
      throw throwError(response);
    }
    return response;
  }
}
